










































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';
import { relationInfo, thirdRelationInfo } from '@/api/strategyTag';
import { getDetail } from '@/api/project';

const columns = [
  {
    title: '关联人姓名',
    dataIndex: 'name',
    key: 'name',
    width: '25%'
  },
  {
    title: '关联项目数量',
    key: 'projectNum',
    width: '25%',
    scopedSlots: { customRender: 'projectNum' }
    // sorter: (a, b) => a.projectList.length - b.projectList.length,
    // defaultSortOrder: 'descend',
    // sortDirections: ['descend'],
  },
  {
    title: '关联项目名称',
    key: 'projectString',
    width: '50%',
    scopedSlots: { customRender: 'projectString' }
  }
];

let tagOption = {
  label: {
    formatter: '{b}\n{des|{c}}',
    overflow: 'truncate',
    ellipsis: '...',
    rich: {
      des: {
        fontWeight: 'normal',
        lineHeight: '18'
      }
    }
  },
  tooltip: {
    formatter: '{b}：{c}'
  }
};
let relationOption = {
  symbol: 'diamond',
  symbolSize: [120, 40],
  label: {
    color: '#ffffff',
    backgroundColor: 'transparent',
    height: 25
  },
  tooltip: {
    formatter: '{b}：{c}'
  }
};

let projectOption = {
  tooltip: {
    formatter: '{b}'
  }
};

let peopleOption = {
  symbol: 'emptyCircle',
  symbolSize: [40, 40],
  label: {
    color: '#1890ff',
    backgroundColor: 'transparent',
    height: 25
  },
  tooltip: {
    formatter: '{b}'
  }
};

@Component({
  components: {}
})
class SuggestPartcipates extends Vue {
  leaves: number = 0;

  peopleMap: any = {};
  peopleString: string = '';
  tagList: any[] = [];
  projectName: string = '';
  dl: string = '';
  dms: string = '';
  round: string = '';
  sector: string = '';
  secret: string = '';
  showBase: boolean = false;
  showSecret: boolean = false;
  showMember: boolean = false;
  showStage: boolean = false;
  columns: any[] = columns;
  data: any[] = [];
  thirdTagList: any[] = [];

  async mounted() {
    await this.getDetail();
    await this.fetchThirdRelations();
    this.initTable();
    this.suggestPeople();
  }

  async getDetail() {
    let secretMap = {
      1: '普通项目',
      2: '绝密项目',
      3: '专利项目'
    };
    const { data } = await getDetail(this.$route.query.projectId);
    let { showBase, showSecret, showMember, showStage, base, member, secret, stage } = data;
    if (showBase) {
      this.projectName = base.name;
      this.sector = base.sectorName;
    }
    if (showMember) {
      this.dl = member.dls.map(_ => _.nickname).join(',');
      this.dms = member.dms.map(_ => _.nickname).join(',');
    }
    if (showStage) {
      this.round = `${stage.raisingRoundName}轮${stage.phase === 0 ? '发展期' : '融资期'}`;
    }
    if (showSecret) {
      this.secret = secretMap[secret.secret];
    }
    this.showBase = showBase;
    this.showSecret = showSecret;
    this.showMember = showMember;
    this.showStage = showStage;
  }
  async fetchRelations() {
    try {
      let res = await relationInfo({ projectId: this.$route.query.projectId });
      if (res.code === 200 && res.data) {
        let { list } = res.data;
        this.tagList = list;
      }
    } catch (e) {}
  }

  async fetchThirdRelations() {
    try {
      let res = await thirdRelationInfo({ projectId: this.$route.query.projectId });
      if (res.code === 200 && res.data) {
        let { list } = res.data;
        this.thirdTagList = list;
        return '';
      }
    } catch (e) {}
  }

  // 生成树的节点
  initData() {
    this.peopleMap = {};
    let { tagList } = this;
    if (!tagList.length) {
      this.tagList = [];
      return;
    }
    this.leaves = 0;
    let data = {
      name: this.projectName,
      label: {
        formatter: '{b}',
        overflow: 'truncate',
        ellipsis: '...'
      },
      children: [] as any[]
    };
    data.children = tagList.map(tagInfo => {
      let { tag, related } = tagInfo;
      let relationChildren = this.initRelated(related);
      return {
        ...tagOption,
        name: tag.name,
        value: tag.description,
        children: relationChildren
      };
    });
    this.draw(data);
  }

  // 生成相关的关系&标签节点
  initRelated(related) {
    let relationChildren: any[] = [];
    related.forEach(_ => {
      let { tag, relation, projectList } = _;
      let relationItem = relationChildren.find(item => item.id === relation.id);
      if (relationItem) {
        relationItem.children.push({
          ...tagOption,
          name: `${tag.name}(${projectList.length})`,
          value: tag.description,
          children: this.initRelatedProject(projectList)
        });
      } else {
        relationChildren.push({
          ...relationOption,
          name: relation.name,
          id: relation.id,
          value: relation.description,
          children: [
            {
              ...tagOption,
              name: `${tag.name}(${projectList.length})`,
              value: tag.description,
              children: this.initRelatedProject(projectList)
            }
          ]
        });
      }
    });
    relationChildren.forEach(relation => {
      relation.projectNum = relation.children.reduce((num, item) => {
        return num + item.children.length;
      }, 0);
      relation.children.sort((a, b) => {
        return b.children.length - a.children.length;
      });
    });
    relationChildren.sort((a, b) => {
      if (a.name === '相同' || b.name === '相同') {
        return a.name === '相同' ? -1 : 1;
      } else {
        return b.projectNum - a.projectNum;
      }
    });
    return relationChildren;
  }

  // 生成相关的项目&人员节点
  initRelatedProject(projectList) {
    return projectList.map(_ => {
      // this.leaves++;
      let { peopleMap } = this;
      let childrenTmp = _.relatedPersons.map(_ => {
        // 这个leaves决定了图表高度
        this.leaves++;
        if (peopleMap[_.name]) {
          peopleMap[_.name]++;
        } else {
          peopleMap[_.name] = 1;
        }
        return {
          ...peopleOption,
          name: _.name
        };
      });
      return {
        ...projectOption,
        name: _.name,
        children: childrenTmp
      };
    });
  }

  initTable() {
    this.peopleMap = {};
    let { peopleMap } = this;

    this.thirdTagList.forEach(_ => {
      if (_.relatedPersons.length > 0) {
        // 排序

        _.relatedPersons.sort((a, b) => b.projectList.length - a.projectList.length);

        _.relatedPersons.forEach(e => {
          if (peopleMap[e.name]) {
            peopleMap[e.name] += e.projectList.length;
          } else {
            peopleMap[e.name] = e.projectList.length;
          }
        });
      }
    });
  }

  suggestPeople() {
    let { peopleMap } = this;
    this.peopleString =
      Object.keys(peopleMap)
        .map(_ => ({
          name: _,
          num: peopleMap[_]
        }))
        .sort((a, b) => b.num - a.num)
        .map(_ => `${_.name}(${_.num})`)
        .join('、') || '暂无推荐人员';
  }

  async callback(key) {
    console.log(key);
    if (+key === 1) {
      await this.fetchRelations();
      this.initData();
      this.suggestPeople();
    } else if (+key === 2) {
      await this.fetchThirdRelations();
      this.initTable();
      this.suggestPeople();
    }
  }

  draw(data) {
    let height = this.leaves * 60 + 40;
    let element = document.getElementById('suggestChart') as any;
    element.style.height = `${height}px`;
    let myChart = echarts.init(element);
    let option = {
      tooltip: {
        trigger: 'item',
        triggerOn: 'mousemove'
      },
      series: [
        {
          type: 'tree',
          id: 0,
          name: 'tree1',
          data: [data],
          symbol: 'emptyRect',
          top: 20,
          left: 100,
          bottom: 20,
          right: 100,
          symbolSize: [118, 30],
          edgeShape: 'polyline',
          edgeForkPosition: '63%',
          initialTreeDepth: 5,
          expandAndCollapse: false,

          lineStyle: {
            width: 2
          },
          itemStyle: {
            borderWidth: 10,
            shadowColor: '#ff0000'
          },

          label: {
            color: '#1890ff',
            backgroundColor: '#e6f7ff',
            position: 'inside',
            verticalAlign: 'middle',
            align: 'center',
            borderWidth: 0,
            width: 120,
            height: 30,
            fontWeight: 'bold',
            overflow: 'truncate',
            ellipsis: '...'
          },
          animationDuration: 550,
          animationDurationUpdate: 750
        }
      ]
    };
    myChart.setOption(option);
    myChart.resize({ height: this.leaves * 60 + 40 });
  }
}

export default SuggestPartcipates;
